<template>
  <div>
    <div class="text-xs-center py-4" v-if="loadingAstonAdmin">
      <div class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>
    <v-container v-else>
      <v-layout class="mb-3">
        <v-flex>
          <h2 class="mt-0">{{ $t('Admin') }}</h2>
        </v-flex>
        <v-flex shrink>
          <v-btn color="primary" @click="showAdd = true"
            ><v-icon class="mr-1">add</v-icon> {{ $t('Add') }}</v-btn
          >
        </v-flex>
      </v-layout>
      <template v-for="(admin, index) in astonAdmins">
        <v-card class="mb-2" :key="index">
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-avatar size="40" class="ma-1"><img :src="admin.image_url"/></v-avatar>
                {{ admin.aston_code ? `${admin.aston_code}: ` : '' }} {{ admin.name }} ({{
                  admin.symbol
                }})
              </v-flex>
              <v-flex shrink>
                <v-btn
                  small
                  fab
                  outline
                  @click="
                    currentAdmin = admin
                    showEdit = true
                  "
                  ><v-icon small>edit</v-icon></v-btn
                >
                <v-btn small fab outline @click="deleteAdmin(admin)"
                  ><v-icon small>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </template>
      <aston-admin-manage
        v-if="showAdd"
        v-model="showAdd"
        @saveAdmin="addAdmin"
      ></aston-admin-manage>
      <aston-admin-manage
        v-if="showEdit"
        v-model="showEdit"
        :data="currentAdmin"
        @saveAdmin="editAdmin"
      ></aston-admin-manage>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AstonAdminManage from './AstonAdminManage'
import api from '@/api'

export default {
  components: {
    AstonAdminManage
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins'
    })
  },
  data() {
    return {
      showAdd: false,
      currentAdmin: null,
      showEdit: false
    }
  },
  mounted() {
    this.$store.dispatch('loadAstonAdmins')
  },
  methods: {
    addAdmin({ admin, oncomplete }) {
      var vm = this
      api.addastonadmin({ body: admin }, (error, response) => {
        if (error) {
          return false
        }
        if (response.data && response.data.data) {
          var admins = this.astonAdmins
          admins.push(response.data.data)
          vm.$store.commit('UPDATE_ASTON_ADMIN', admins)
          oncomplete()
        }
      })
    },
    editAdmin({ admin, oncomplete }) {
      var vm = this
      api.saveastonadmin({ body: admin }, (error, response) => {
        if (error) {
          return false
        }
        var admins = this.astonAdmins
        var index = admins.findIndex(el => {
          return el.id == admin.id
        })
        if (index != -1) {
          admins[index] = admin
          vm.$store.commit('UPDATE_ASTON_ADMIN', admins)
          oncomplete()
        }
      })
    },
    deleteAdmin(admin) {
      var vm = this
      this.$swal
        .fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteAstonAdmin(
              {
                body: {
                  id: admin.id
                }
              },
              (error, response) => {
                if (error) {
                  vm.$store.dispatch('loading')
                  return false
                }

                var admins = this.astonAdmins
                var index = admins.findIndex(el => {
                  return el.id == admin.id
                })
                if (index != -1) {
                  admins.splice(index, 1)
                  vm.$store.commit('UPDATE_ASTON_ADMIN', admins)
                }
                vm.$store.dispatch('loading')
              }
            )
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/AstonAdmin.vue